module.exports = __webpack_public_path__ + "static/media/icon-fashion.6a693842.png";